import React from 'react';
import { ExchangeType, UNIT } from '../../../settings/settings';
import Case from '../../Shared/Switch/Case';
import Switch from '../../Shared/Switch/Switch';
import { currency, formatPercent } from '../../../utils/utils';
import { ExchangeTypeOrUnit, Fund } from '../types';

function effectiveDisplayUnit(
  fundUnit: string,
  exchangeType: ExchangeTypeOrUnit
): ExchangeTypeOrUnit {
  return exchangeType !== ExchangeType.ONE_TO_MANY ? UNIT.ALL_SHARES : fundUnit;
}

interface ExchangeSummaryToAmountProps {
  exchangeType: ExchangeTypeOrUnit;
  fund: Fund;
}

const ExchangeSummaryToAmount: React.FC<ExchangeSummaryToAmountProps> = ({
  exchangeType,
  fund,
}) => (
  <Switch test={effectiveDisplayUnit(fund.grossUnit, exchangeType)}>
    <Case value={UNIT.ALL_REMAINING}>All Remaining</Case>

    <Case value={UNIT.ALL_SHARES}>All</Case>

    <Case value={UNIT.DOLLARS}>{currency(fund.grossAmount)} Dollars</Case>

    <Case value={UNIT.PERCENT}>{formatPercent(fund.grossAmount)}</Case>
  </Switch>
);

export default ExchangeSummaryToAmount;
